module.exports = {"pathContext":{"name":"DeclineReasonInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"isActive","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-decline-reason-input.json
// module id = 1422
// module chunks = 116845206868004